import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { selects } from '../../constants/selects.const';
import { MessageService } from 'primeng/api';
import { User } from '@bl-interfaces/user';

@Component({
  selector: 'bid-users-role-table',
  templateUrl: './users-role-table.component.html',
  styleUrls: ['./users-role-table.component.scss'],
})
export class UsersRoleTableComponent implements OnInit {
  @Input() headerTable;
  @Input() bodyTable;
  @Input() updateForm;
  // eslint-disable-next-line
  @Output() onDelete: EventEmitter<User> = new EventEmitter<User>();
  // eslint-disable-next-line
  @Output() onStatusChange: EventEmitter<User> = new EventEmitter<User>();
  userName;
  userEmail;
  rolesCombo;
  updateRoleUser: number;
  display: boolean;
  addUser: {};
  status: boolean;
  displayDelete: boolean;
  displayDisable: boolean;
  userData: User;
  colUser: number;

  constructor(private messageService: MessageService) {
    this.userName = null;
    this.userEmail = null;
  }

  ngOnInit() {
    this.rolesCombo = selects.pages.users.roles;
  }

  showToastSuccess(title, msg, key) {
    this.messageService.add({
      key,
      severity: 'success',
      summary: title,
      detail: msg,
    });
  }

  toggleDialogDelete(user, display) {
    this.displayDelete = display;
    this.userData = {
      displayName: user.displayName,
      mail: user.mail,
      role: user.role,
      status: user.status,
    };
  }

  deleteUser(event) {
    this.displayDelete = false;
    if (event.submit) {
      this.onDelete.emit(event.user);
    }
  }

  updateStatus(user) {
    this.onStatusChange.emit(user);
  }
}
